import React,{ forwardRef, useState, useImperativeHandle, useRef } from 'react';
import { i18nIntl } from '../../lib/ep';
import { FormattedMessage } from 'react-intl';

import FloatingLayer from '../builder/FloatingLayer';
import ButtonCollection from '../builder/ButtonCollection';
import { SecondaryButton } from '../builder/ActionButton';
import SaveButton from '../builder/SaveButton';
import SectionTitle from '../builder/SectionTitle';
import SectionSubtitle from '../builder/SectionSubtitle';
import ActionLink from '../builder/ActionLink';

const TemplateSaveWarning = forwardRef((props, ref) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	
	const [ display, setDisplay ] = useState(false);

	const callback = useRef(null);

	useImperativeHandle(ref, () => ({
		show(cb) {
			setDisplay(true);
			callback.current = cb;
		},
	}), []);

	const close = () => {
		setDisplay(false);
	};

	const confirm =(e, cb) => {
		delete props.pm.attributes.old_layout_props;
		delete props.pm.attributes.old_design_template_id;
		props.pm.trigger('change');
		props.pm.save((r) => {
			if(cb != undefined) cb();
			if (callback.current) callback.current(r); 
			close();
		});
	};
	
	if(!display) return null;
	
	return (
		<FloatingLayer _class={{ size:'small' }} backButton={close}>
			<div>
				<SectionTitle _class={{ icon:'knk-alert redIcon' }}>Warning</SectionTitle>

				<SectionSubtitle>If you save changes, the design template you are previewing will be applied and will permanently replace the initial design template.</SectionSubtitle>

				<SectionSubtitle autotranslate={false}><FormattedMessage id="If you want to return to the initial design template, do not save the changes now and go to the {link} section to retrieve the initial design." values={{ link:<ActionLink _href="#template" autotranslate={false}>{i18n("Design")} &gt; {i18n("Template")}</ActionLink>}} /></SectionSubtitle>

				<ButtonCollection in_floating={true}>
					<SaveButton onClick={confirm}>Confirm and save</SaveButton>

					<SecondaryButton onClick={close}>Close</SecondaryButton>

					<p>{i18n("Are you sure you want to continue?")}</p>
				</ButtonCollection>
			</div>
		</FloatingLayer>
	)
});

export default TemplateSaveWarning;